import { Link  } from "react-router-dom"; 
import {FcSms, FcOrgUnit,FcManager, FcCollect } from "react-icons/fc";

import HandleCurrentPath from "./HandleCurrentPath";

import { FiUsers } from "react-icons/fi";
import { RiMoneyDollarBoxLine } from "react-icons/ri";

import React, { useState } from 'react';

const Menu = () =>{

  const pathname = window.location.pathname;
  const [clientMgtOpen, setClientMgtOpen] = useState(false);
  const [smsOpen, setSmsOpen] = useState(false);
  const [transactionsOpen, setTransactionsOpen] = useState(false);
  const [userMgtOpen, setUserMgtOpen] = useState(false);
  const [salesMgtOpen, setSalesMgtOpen] = useState(false);
  const [productMgtOpen, setProductMgtOpen] = useState(false);
    return(
        <>
        <ul className="mt-6">
                <li className="relative px-6 py-3">
                 
                <HandleCurrentPath staticPath={'/'} currentPath={pathname} />
                <Link
                    className="inline-flex items-center w-full text-sm font-semibold text-gray-800 transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200 dark:text-gray-100"
                    to={"/"}
                >
                    <FcOrgUnit />
                    <span className="ml-4">Dashboard</span>
                </Link>
                </li>
            </ul>

        <ul>

<li className="relative px-6 py-3">
    <button
        className="inline-flex items-center justify-between w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200"
        onClick={() => setSalesMgtOpen(!salesMgtOpen)}
        aria-haspopup="true"
    >
        <span className="inline-flex items-center">
        <FcCollect/>
        <span className="ml-4">Sales</span>
        </span>
        <svg
        className="w-4 h-4"
        aria-hidden="true"
        fill="currentColor"
        viewBox="0 0 20 20"
        >
        <path
            fillRule="evenodd"
            d={salesMgtOpen ? "M14.293 15.293a1 1 0 01-1.414 0L10 12.414l-2.879 2.879a1 1 0 01-1.414-1.414l3.586-3.586a1 1 0 011.414 0l3.586 3.586a1 1 0 010 1.414z" : "M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"}
            clipRule="evenodd"
        />
        </svg>
    </button>
    {salesMgtOpen && (
        <ul className="p-2 mt-2 space-y-2 overflow-hidden text-sm font-medium text-gray-500 rounded-md shadow-inner bg-gray-50 dark:text-gray-400 dark:bg-gray-900">
        {[
            { path: '/packageinstallation', name: 'Package Installation' }, 
        ].map((item) => (
            <li className="px-2 py-1 transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200" key={item.path}>
            <Link className="w-full" to={item.path}>
                {item.name}
            </Link>
            </li>
        ))}
        </ul>
    )}
</li>   

<li className="relative px-6 py-3">
     <HandleCurrentPath staticPath={'/gamelist'} currentPath={pathname} />
     <Link className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200" to={'/gamelist'} >
         <FcManager/>
         <span className="ml-4">Game List </span>
     </Link>
</li>

<li className="relative px-6 py-3">
    <button
        className="inline-flex items-center justify-between w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200"
        onClick={() => setClientMgtOpen(!clientMgtOpen)}
        aria-haspopup="true"
    >
        <span className="inline-flex items-center">
        <FiUsers/>
        <span className="ml-4">Cient Management</span>
        </span>
        <svg
        className="w-4 h-4"
        aria-hidden="true"
        fill="currentColor"
        viewBox="0 0 20 20"
        >
        <path
            fillRule="evenodd"
            d={clientMgtOpen ? "M14.293 15.293a1 1 0 01-1.414 0L10 12.414l-2.879 2.879a1 1 0 01-1.414-1.414l3.586-3.586a1 1 0 011.414 0l3.586 3.586a1 1 0 010 1.414z" : "M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"}
            clipRule="evenodd"
        />
        </svg>
    </button>
    {clientMgtOpen && (
        <ul className="p-2 mt-2 space-y-2 overflow-hidden text-sm font-medium text-gray-500 rounded-md shadow-inner bg-gray-50 dark:text-gray-400 dark:bg-gray-900">
        {[
            { path: '/client', name: 'Client List' },
            { path: '/cpanel', name: 'Control Panel' },
            { path: '/clientBalances', name: 'Client Balances' }, 
        ].map((item) => (
            <li className="px-2 py-1 transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200" key={item.path}>
            <Link className="w-full" to={item.path}>
                {item.name}
            </Link>
            </li>
        ))}
        </ul>
    )}
</li>


 

<li className="relative px-6 py-3">
    <button
        className="inline-flex items-center justify-between w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200"
        onClick={() => setUserMgtOpen(!userMgtOpen)}
        aria-haspopup="true"
    >
        <span className="inline-flex items-center">
        <FcManager/>
        <span className="ml-4">User Management</span>
        </span>
        <svg
        className="w-4 h-4"
        aria-hidden="true"
        fill="currentColor"
        viewBox="0 0 20 20"
        >
        <path
            fillRule="evenodd"
            d={userMgtOpen ? "M14.293 15.293a1 1 0 01-1.414 0L10 12.414l-2.879 2.879a1 1 0 01-1.414-1.414l3.586-3.586a1 1 0 011.414 0l3.586 3.586a1 1 0 010 1.414z" : "M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"}
            clipRule="evenodd"
        />
        </svg>
    </button>
    {userMgtOpen && (
        <ul className="p-2 mt-2 space-y-2 overflow-hidden text-sm font-medium text-gray-500 rounded-md shadow-inner bg-gray-50 dark:text-gray-400 dark:bg-gray-900">
        {[
      
            { path: '/users', name: 'Users' },
            { path: '/roles', name: 'Roles' },
            { path: '/permissions', name: 'Permissions' },
        ].map((item) => (
            <li className="px-2 py-1 transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200" key={item.path}>
            <Link className="w-full" to={item.path}>
                {item.name}
            </Link>
            </li>
        ))}
        </ul>
    )}
</li>

<li className="relative px-6 py-3">
    <button
        className="inline-flex items-center justify-between w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200"
        onClick={() => setProductMgtOpen(!productMgtOpen)}
        aria-haspopup="true"
    >
        <span className="inline-flex items-center">
        <FcCollect/>
        <span className="ml-4">Products</span>
        </span>
        <svg
        className="w-4 h-4"
        aria-hidden="true"
        fill="currentColor"
        viewBox="0 0 20 20"
        >
        <path
            fillRule="evenodd"
            d={productMgtOpen ? "M14.293 15.293a1 1 0 01-1.414 0L10 12.414l-2.879 2.879a1 1 0 01-1.414-1.414l3.586-3.586a1 1 0 011.414 0l3.586 3.586a1 1 0 010 1.414z" : "M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"}
            clipRule="evenodd"
        />
        </svg>
    </button>
    {productMgtOpen && (
        <ul className="p-2 mt-2 space-y-2 overflow-hidden text-sm font-medium text-gray-500 rounded-md shadow-inner bg-gray-50 dark:text-gray-400 dark:bg-gray-900">
        {[
            { path: '/solarpackage', name: 'Solar Packages' },
            { path: '/packageitem', name: 'Package Items' }, 
        ].map((item) => (
            <li className="px-2 py-1 transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200" key={item.path}>
            <Link className="w-full" to={item.path}>
                {item.name}
            </Link>
            </li>
        ))}
        </ul>
    )}
</li>

 

<li className="relative px-6 py-3">
    <button
        className="inline-flex items-center justify-between w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200"
        onClick={() => setSmsOpen(!smsOpen)}
        aria-haspopup="true"
    >
        <span className="inline-flex items-center">
        <FcSms/>
        <span className="ml-4">SMS</span>
        </span>
        <svg
        className="w-4 h-4"
        aria-hidden="true"
        fill="currentColor"
        viewBox="0 0 20 20"
        >
        <path
            fillRule="evenodd"
            d={smsOpen ? "M14.293 15.293a1 1 0 01-1.414 0L10 12.414l-2.879 2.879a1 1 0 01-1.414-1.414l3.586-3.586a1 1 0 011.414 0l3.586 3.586a1 1 0 010 1.414z" : "M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"}
            clipRule="evenodd"
        />
        </svg>
    </button>
    {smsOpen && (
        <ul className="p-2 mt-2 space-y-2 overflow-hidden text-sm font-medium text-gray-500 rounded-md shadow-inner bg-gray-50 dark:text-gray-400 dark:bg-gray-900">
        {[
            { path: '/interactiveSms', name: 'Interactive SMS' }, 
            { path: '/smsMessage', name: 'Bulk Out' },
            { path: '/phonebook', name: 'Phonebook' },
            { path: '/phonebookupload', name: 'Upload Contacts' },
            { path: '/bulkbroadcast', name: 'Bulk Broadcast' },
            { path: '/senderid', name: 'Senderid' },
        ].map((item) => (
            <li className="px-2 py-1 transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200" key={item.path}>
            <Link className="w-full" to={item.path}>
                {item.name}
            </Link>
            </li>
        ))}
        </ul>
    )}
</li>

 


<li className="relative px-6 py-3">
    <button
        className="inline-flex items-center justify-between w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200"
        onClick={() => setTransactionsOpen(!transactionsOpen)}
        aria-haspopup="true"
    >
        <span className="inline-flex items-center">
        <RiMoneyDollarBoxLine/>
        <span className="ml-4">Transactions</span>
        </span>
        <svg
        className="w-4 h-4"
        aria-hidden="true"
        fill="currentColor"
        viewBox="0 0 20 20"
        >
        <path
            fillRule="evenodd"
            d={transactionsOpen ? "M14.293 15.293a1 1 0 01-1.414 0L10 12.414l-2.879 2.879a1 1 0 01-1.414-1.414l3.586-3.586a1 1 0 011.414 0l3.586 3.586a1 1 0 010 1.414z" : "M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"}
            clipRule="evenodd"
        />
        </svg>
    </button>
    {transactionsOpen && (
        <ul className="p-2 mt-2 space-y-2 overflow-hidden text-sm font-medium text-gray-500 rounded-md shadow-inner bg-gray-50 dark:text-gray-400 dark:bg-gray-900">
        {[
            { path: '/deposit', name: 'Deposits' },   
            { path: '/marketingPayouts', name: 'Marketing Payouts' },
            { path: '/b2ctopup', name: 'B2C Top Up' },
            { path: '/userWallet', name: 'UserWallet' }, 
        ].map((item) => (
            <li className="px-2 py-1 transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200" key={item.path}>
            <Link className="w-full" to={item.path}>
                {item.name}
            </Link>
            </li>
        ))}
        </ul>
    )}
</li>
 
 
  </ul>
        </>
    );
}
export default Menu;